import React, { useState, useEffect } from "react";
import clsx from "clsx";
import "rc-slider/assets/index.css";
import RcSlider from "rc-slider";
import * as styles from "./index.module.scss";

const SliderContent = ({ options, onChange, useRange = false, value }) => {
  const rangeValue = useRange && Array.isArray(value) ? value : [0, 100];

  const props = {
    min: 0,
    max: 99,
    step: 1,
    onChange,
    range: useRange,
    value: useRange ? rangeValue : value,
    ...(useRange && { allowCross: false, pushable: 15 }),
  };

  return (
    <div className="tw:flex-column">
      <div className={styles.inputLegend}>
        {options.map((option) => (
          <span key={option}>{option}</span>
        ))}
      </div>
      <RcSlider
        {...props}
        className={clsx(
          styles.quizSliderRc,
          useRange && styles.quizSliderRcRange,
        )}
        data-testid="quiz-slider"
      />
    </div>
  );
};

/**
 * QuizSlider is wrapped in a client-side only renderer to handle rc-slider's SSR limitations.
 *
 * Why this is needed:
 * 1. rc-slider attempts to access browser-specific APIs (like window, document) during initialization
 * 2. During server-side rendering in Remix, these APIs don't exist, causing the "Element type is invalid" error
 * 3. The component must be prevented from rendering during SSR to avoid these errors
 *
 * Implementation details:
 * - Uses useState/useEffect to detect client-side rendering
 * - Only renders rc-slider after the component has mounted on the client
 * - Returns an empty fragment during SSR to prevent hydration mismatches
 *
 * Alternative approaches considered:
 * - remix-utils/client-only: Adds extra dependencies and has React Router version conflicts
 * - Dynamic imports: More complex and still requires client-side detection
 * - CSS-only fallback: Could cause layout shifts during hydration
 */
export const QuizSlider = (props) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return <></>;
  }

  return <SliderContent {...props} />;
};
